/* global axios */
import ApiClient from './ApiClient';

class ScheduledReportsAPI extends ApiClient {
  constructor() {
    super('scheduled_reports', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { scheduled_report: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { scheduled_report: data });
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  reportTypes() {
    return axios.get(`${this.url}/report_types`);
  }

  formOptions() {
    return axios.get(`${this.url}/form_options`);
  }
}

export default new ScheduledReportsAPI();
